export default __webpack_public_path__ + "static/media/depature-icon.ff955931.svg";